import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/building-blocks/instrument-radial/instrument-radial.js';
      import {InstrumentState, Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
import {ObcGaugeRadialType, GaugeRadialAdvice} from '@oicl/openbridge-webcomponents/dist/building-blocks/instrument-radial/instrument-radial.js';
import {TickmarkStyle} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/tickmark.js';

      export interface Props {
     state?: InstrumentState;
     priority?: Priority;
     value?: number;
     maxValue?: number;
     minValue?: number;
     getAngle?: (v: number) => number;
     needleColor?: string | undefined;
     barColor?: string | undefined;
     showLabels?: boolean;
     primaryTickmarkInterval?: number | undefined;
     secondaryTickmarkInterval?: number | undefined;
     tertiaryTickmarkInterval?: number | undefined;
     type?: ObcGaugeRadialType;
     needleType?: ObcGaugeRadialType;
     tickmarksInside?: boolean;
     tickmarkStyle?: TickmarkStyle;
     advices?: GaugeRadialAdvice[];
     clipTop?: number;
     clipBottom?: number;
     zoomToFitArc?: boolean;
     setpoint?: number | undefined;
     newSetpoint?: number | undefined;
     atSetpoint?: boolean;
     touching?: boolean;
     autoAtSetpoint?: boolean;
     autoAtSetpointDeadband?: number;
     setpointAtZeroDeadband?: number;
     setpointOverride?: boolean;
     animateSetpoint?: boolean
   }

      
  
      export type {InstrumentState, Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
export type {ObcGaugeRadialType, GaugeRadialAdvice} from '@oicl/openbridge-webcomponents/dist/building-blocks/instrument-radial/instrument-radial.js';
export type {TickmarkStyle} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/tickmark.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcInstrumentRadial',
  props: {
    state: {},
    priority: {},
    value: {},
    maxValue: {},
    minValue: {},
    getAngle: { type: Function },
    needleColor: {},
    barColor: {},
    showLabels: { type: Boolean },
    primaryTickmarkInterval: {},
    secondaryTickmarkInterval: {},
    tertiaryTickmarkInterval: {},
    type: {},
    needleType: {},
    tickmarksInside: { type: Boolean },
    tickmarkStyle: {},
    advices: {},
    clipTop: {},
    clipBottom: {},
    zoomToFitArc: { type: Boolean },
    setpoint: {},
    newSetpoint: {},
    atSetpoint: { type: Boolean },
    touching: { type: Boolean },
    autoAtSetpoint: { type: Boolean },
    autoAtSetpointDeadband: {},
    setpointAtZeroDeadband: {},
    setpointOverride: { type: Boolean },
    animateSetpoint: { type: Boolean }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-instrument-radial',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})